export const sortData = (data, sortConfig) => {
  if (!sortConfig.key) return data;

  return [...data].sort((a, b) => {
    // Handle nested objects (e.g., PipelineStage.name or OpportunityStatus.name)
    const aValue = sortConfig.key.includes(".")
      ? sortConfig.key.split(".").reduce((obj, key) => obj?.[key], a)
      : a[sortConfig.key];

    const bValue = sortConfig.key.includes(".")
      ? sortConfig.key.split(".").reduce((obj, key) => obj?.[key], b)
      : b[sortConfig.key];

    if (aValue < bValue) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });
};